<template>
  <div>
    <div class="as-topbar">
      <div class="as-breadcrumb">{{ breadcrumb }}</div>
      <div class="as-topbar__right">
        <span v-if="mostrarFecha" class="as-fecha-larga">{{ fechaLarga }}</span>
        <div v-if="mostrarReloj" class="as-hora-oficial">
          <div class="as-hora-oficial__icon">
            <v-icon color="#1d4ed8" size="20">mdi-clock-outline</v-icon>
          </div>
          <div>
            <div class="as-hora-oficial__label">Hora oficial</div>
            <div class="as-hora-oficial__value">{{ horaOficial }}</div>
          </div>
        </div>
        <slot name="top-right" />
      </div>
    </div>

    <div class="as-intro">
      <div class="as-intro__row">
        <div>
          <div class="as-kicker">{{ kicker }}</div>
          <h1 class="as-title">{{ title }}</h1>
          <p v-if="subtitle" class="as-subtitle">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.actions" class="as-intro__actions">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESES_PLANILLA } from '../rrhhLegajo'

function pad(n) {
  return String(n).padStart(2, '0')
}

export default {
  name: 'AsPageHeader',
  props: {
    breadcrumb: { type: String, default: 'Legajo RRHH' },
    kicker: { type: String, default: 'GESTIÓN DE PERSONAL' },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    mostrarFecha: { type: Boolean, default: true },
    mostrarReloj: { type: Boolean, default: false },
  },
  data() {
    return {
      horaOficial: '00:00:00',
      timer: null,
    }
  },
  computed: {
    fechaLarga() {
      const d = new Date()
      const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
      return `${dias[d.getDay()]}, ${d.getDate()} de ${MESES_PLANILLA[d.getMonth()].toLowerCase()} de ${d.getFullYear()}`
    },
  },
  mounted() {
    if (!this.mostrarReloj) return
    this.tick()
    this.timer = setInterval(this.tick, 1000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    tick() {
      const d = new Date()
      this.horaOficial = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
  },
}
</script>
